import { IconButton, SxProps, Theme } from '@mui/material';
import { memo } from 'react';

interface IImageIconButtonProps {
  id: string;
  alt: string;
  src: string;
  sx?: SxProps<Theme>;
}
function ImageIconButton({ id, alt, src, sx = {} }: IImageIconButtonProps): JSX.Element {
  return (
    <IconButton
      color="primary"
      aria-label={id}
      sx={{
        width: 46,
        height: 46,
        ...sx,
      }}
    >
      <img alt={alt} src={src} loading="lazy" style={{ objectFit: 'contain' }} />
    </IconButton>
  );
}

export default memo(ImageIconButton);
